// extracted by mini-css-extract-plugin
export default {"grayScaleBackground":"Loading_grayScaleBackground__-DR4p","window":"Loading_window__vro5U","center":"Loading_center__r+gQa","icon":"Loading_icon__QakBw","spin":"Loading_spin__-88Jy"};